import React from 'react';
export function AudienceIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.177 13.233a4.562 4.562 0 001.043-2.9V8.56a4.526 4.526 0 00-6.841-3.923 5.13 5.13 0 00-.846-1.178A5 5 0 004 7v2a5 5 0 001.258 3.312A5.01 5.01 0 002 17v3a2 2 0 002 2h16.11A1.892 1.892 0 0022 20.11v-2.67a4.556 4.556 0 00-2.823-4.207zM4 20v-3a3 3 0 013-3 1 1 0 001-1v-.54a1 1 0 00-.5-.868A3 3 0 016 9V7a3 3 0 116 0v2a3 3 0 01-.863 2.109c-.19.185-.4.347-.63.48a.999.999 0 00-.507.871V13a1 1 0 001 1 3 3 0 013 3v3H4zm16 0h-4v-3a5.007 5.007 0 00-3.255-4.686A4.992 4.992 0 0014 9V7c0-.115-.025-.226-.033-.339a2.626 2.626 0 013.5.08 2.58 2.58 0 01.753 1.819v1.77a2.546 2.546 0 01-1.275 2.211 1 1 0 00-.5.869v.48a1 1 0 001 1A2.558 2.558 0 0120 17.44V20z"
  }));
}